export default {
  zones: state => state.zones,
  zone: state => state.zone,
  icon: state => state.icon
}
